import Fingerprint2 from 'fingerprintjs2';

export default class IdentityService {
  static fingerprint: any;
  
  static initialise(){
    return new Promise(function(resolve, reject) {
      if (window.requestIdleCallback) {
          requestIdleCallback(() => {
            IdentityService._generateFingerprint((fingerprint: unknown)=>{
              resolve(fingerprint);  
            });
          })
        } else {
          setTimeout(() => {
            IdentityService._generateFingerprint((fingerprint: unknown)=>{
              resolve(fingerprint);  
            });
          }, 500)
        }
    });
  }
    
  static _generateFingerprint(callback: { (fingerprint: any): void; (fingerprint: any): void; (arg0: any): void; }){
    Fingerprint2.get((components: any[]) => {
      this.fingerprint = Fingerprint2.x64hash128(components.map(function (pair: { value: any; }) { return pair.value }).join(), 31);
      
      if(callback){
        callback(this.fingerprint);
      }
    })
  }   

  static getFingerprint(){
    return this.fingerprint;
  }
}